<template>
  <div class="carousel">
    <div class="carousel__slides">
      <flickity ref="flickity" :options="flickityOptions">
      <div
        class="carousel__slides__cell"
        v-for="(p, i) in projects"
        :key="i"
        :class="{ active: i == 0}"
      >
        <div class="project">
          <div class="project__image">
            <img v-if="p.imageId" :id="'Img-item-' + i" :src="`${fileUrl}${p.imageId}`" width="292" height="200" alt />
            <img v-else src="http://placehold.it/292x200" alt />
          </div>

          <div class="project__content">
            <h3 class="h5 project__title">{{ p.title }}</h3>

            <div class="project__tags">
              <ul class="list-reset">
                <li v-if="p.awarded">
                  <i class="icomoon icon-trophy" aria-hidden="true"></i>Awarded
                </li>
                <li>
                  <i class="icomoon icon-tag" aria-hidden="true"></i>
                  {{ p.cost | currency(2) }}
                </li>
              </ul>
            </div>

            <div class="project__description">
              <p>{{ p.description }}</p>
            </div>
          </div>
        </div>
      </div>
      </flickity>
    </div>

    <div class="carousel__controls">
      <button class="btn btn-link btn-icon carousel__controls__prev" type="button" @click="previous()">
        <i class="icomoon icon-chevron-left" aria-hidden="true"></i>
        <span class="sr-only">Previous slide</span>
      </button>

      <div class="carousel__info">
        <span class="carousel__info__current"></span>
        <span class="carousel__info__total"></span>
      </div>

      <button class="btn btn-link btn-icon carousel__controls__next" type="button" @click="next()">
        <i class="icomoon icon-chevron-right" aria-hidden="true"></i>
        <span class="sr-only">Next slide</span>
      </button>
    </div>
  </div>
</template>

<script>
import Flickity from 'vue-flickity';
export default {
  name: "projectSummary",
  components: {
    Flickity
  },
  data() {
    return {
      fileUrl: `${process.env.VUE_APP_API_URL}api/v1/file/`,
      flickityOptions: {
        initialIndex: 2,
        prevNextButtons: false,
        wrapAround: true
      }
    };
  },
  props: {
    projects: {
      type: Array,
      default: () => {}
    }
  },
  methods: {
      next() {
      this.$refs.flickity.next();
    },
    
    previous() {
      this.$refs.flickity.previous();
    },
  },
  computed:{
     ind() {
      return this.$refs.flickity.selectedIndex;
    },
  }
};
</script>

